import { supabase } from "@/integrations/supabase/client";
import type { AppointmentFinancialRow } from "@/lib/utils/appointment-financial";

export const reconcileAppointmentFinancial = async (
  appointmentId: string,
): Promise<AppointmentFinancialRow> => {
  // The generated Supabase types do not include additive RPCs until types are regenerated.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const { data, error } = await (supabase as any).rpc("reconcile_appointment_financial", {
    p_appointment_id: appointmentId,
  });

  if (error) throw error;

  if (!data) {
    throw new Error("Failed to reconcile appointment financial state.");
  }

  return data as AppointmentFinancialRow;
};
